// extracted by mini-css-extract-plugin
export var cardHeader = "_st-0";
export var reorderHandle = "_st-3";
export var titleArea = "_st-1";
export var titleAreaWithHandle = "_st-2";